import { render, staticRenderFns } from "./WhatsappMain.vue?vue&type=template&id=8542160c&scoped=true"
import script from "./WhatsappMain.vue?vue&type=script&lang=js"
export * from "./WhatsappMain.vue?vue&type=script&lang=js"
import style0 from "./WhatsappMain.vue?vue&type=style&index=0&id=8542160c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8542160c",
  null
  
)

export default component.exports